module.exports = {"TXTWCL_Deposit_66":{"id":"TXTWCL_Deposit_66","defaultMessage":"Κατάθεση"}}